module.exports = __webpack_public_path__ + "img/classify_img6.ca0f3597.png";